import React, { lazy, Suspense } from 'react';

const SmallScreenFallback = lazy(() => import('./index'));

const SmallScreenFallbackLazy = (props: ComponentProps<typeof SmallScreenFallback>) => (
  <Suspense fallback={null}>
    <SmallScreenFallback {...props} />
  </Suspense>
);

export default SmallScreenFallbackLazy;
